'use strict';

import versioner from '../versioner';
import process from './process';

for (var version of [
	'olathe_sewer_generic',
	'olathe_sewer_a',
	'olathe_sewer_b',
	'olathe_sewer_c',
	'olathe_water_generic',
	'olathe_water_a',
	'olathe_water_b',
	'olathe_water_c',
	'olathe_sewer_generic_v2',
	'olathe_sewer_mon',
	'olathe_sewer_tue',
	'olathe_sewer_wed',
	'olathe_sewer_thu',
	'olathe_sewer_fri',
	'olathe_sewer_sat',
	'olathe_sewer_sun',
	'olathe_water_generic_v2',
	'olathe_water_mon',
	'olathe_water_tue',
	'olathe_water_wed',
	'olathe_water_thu',
	'olathe_water_fri',
	'olathe_water_sat',
	'olathe_water_sun',
]) {
	versioner[version] = {process: process};
}


const MODULE_NAME = 'daupler.incidents.versions.olathe';

export default MODULE_NAME;
